import $ from 'jquery';
import {UiWidget} from "./abstract";
import {scrollToY} from '../utilities/sink';

/**
 * @example <div data-init-scroll-to='{"target":"parent", "treeSelector": ".ce-stage-header", "position":"bottom", "offset": -100, "speed": 1200}'>
 */
export class ScrollToWidget extends UiWidget{

	/**
	 *
	 * @param selector
	 */
	constructor(selector){
		super(selector);
	}

	/**
	 *
	 */
	bindEventListeners(): void{
		this.elements.on('click', (e: any) => {
			this.handleClickEvent(e);
		});
	}

	/**
	 *
	 * @param {Event} e
	 */
	handleClickEvent(e: Event){
		let eventTarget: EventTarget = e.currentTarget;

		// inline attribute options
		let options: ScrollToWidgetOptions = JSON.parse((eventTarget as HTMLElement).dataset.initScrollTo);

		options.position = options.position || 'bottom';
		options.offset = options.offset || 0;
		options.speed = options.speed || 1200;

		let scrollTarget, scrollTargetY;

		switch(options.target){
			case 'self':
				scrollTarget = $(eventTarget);
				break;
			case 'parent':
				scrollTarget = $(eventTarget).parent(options.treeSelector).first();
				break;
			case 'child':
				scrollTarget = $(eventTarget).children(options.treeSelector).first();
				break;
			case 'href':
				scrollTarget = $($(eventTarget).attr("href")).first();
				break;
			default:
				scrollTarget = $(options.target).first();
				break;
		}

		if(options.position === 'bottom'){
			scrollTargetY = options.offset + (scrollTarget.outerHeight() + scrollTarget.offset().top);
		}else if(options.position === 'top'){
			scrollTargetY = options.offset + scrollTarget.offset().top;
		}

		scrollToY(scrollTargetY, 1200);
	}
}

interface ScrollToWidgetOptions{
	/**
	 * self|parent|child or selector
	 */
	target: string;

	/**
	 * selector when parent or child
	 */
	treeSelector: string;

	/**
	 * bottom|top
	 */
	position: string;

	/**
	 * positive or negative scroll offset
	 */
	offset: number;

	/**
	 * pixels per second
	 */
	speed: number;
}


// WEBPACK FOOTER //
// ./src/js/widgets/scroll-to.tsx